module.exports = __webpack_public_path__ + "static/media/bed2.9f295e1e.png";